import script from "./WaterfallConfirmationRgister.vue?vue&type=script&setup=true&lang=js"
export * from "./WaterfallConfirmationRgister.vue?vue&type=script&setup=true&lang=js"

import "./WaterfallConfirmationRgister.vue?vue&type=style&index=0&id=a8e00244&setup=true&lang=css"

const __exports__ = script;

export default __exports__